import type { FlowId, StepId } from '../types';

export type ContentKey = { flow: FlowId; step: StepId };

const createContentKeyRecord = <F extends FlowId, S extends readonly StepId[]>(flow: F, steps: S) => {
  const entries = steps.map(step => [step, { flow, step } as const]);
  return Object.fromEntries(entries) as { [K in S[number]]: { flow: F; step: K } };
};

export const contentKeys = {
  pas: createContentKeyRecord('pas', [
    'start',
    'gdpr',
    'login',
    'ask_for_whom',
    'child_info',
    'custody',
    'medindehaver_details',
    'ask_has_old_passport',
    'ask_passport_damage',
    'declaration_lost',
    'ask_previous_citizenship',
    'warn_documentation',
    'ask_height',
    'photo_method',
    'photo_info',
    'contact_info',
    'addressing_name',
    'select_time',
    'summary',
    'sign',
    'payment',
    'confirmation'
  ] as const),
  pas_samtykke: createContentKeyRecord('pas_samtykke', [
    'consent_start',
    'consent_custody',
    'consent_select_child',
    'consent_enter_child',
    'consent_give',
    'consent_form',
    'consent_review',
    'consent_confirmation'
  ] as const),
  koerekort: createContentKeyRecord('koerekort', [
    'dl_start',
    'dl_case_type',
    'dl_category',
    'dl_medical',
    'dl_vision',
    'dl_parent_consent',
    'dl_parent_signature',
    'dl_summary',
    'dl_payment',
    'dl_confirmation'
  ] as const),
  koerekort_samtykke: createContentKeyRecord('koerekort_samtykke', [
    'dlc_start',
    'dlc_guardian',
    'dlc_notify',
    'dlc_guardian_contact',
    'dlc_summary',
    'dlc_confirmation'
  ] as const),
  tidsbestilling: createContentKeyRecord('tidsbestilling', [
    'bk_start',
    'bk_sms',
    'bk_info',
    'bk_summary',
    'bk_confirmation'
  ] as const),
  afbestil: createContentKeyRecord('afbestil', [
    'bk_start',
    'bk_sms',
    'bk_info',
    'bk_summary',
    'bk_confirmation'
  ] as const)
} as const;

